import AnimatedImage from 'core-lib/components/AnimatedImage';
import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import formatCurrency from 'core-lib/utils/currency';
import { formatFuelBalance } from 'core-lib/utils/fuel';
import { useEffect, useMemo, useRef } from 'react';
import {
    ProductCardProp,
    SkuType,
} from 'src/modules/parkplusStoreV2/types/product';
import { trackProductViewedStoreV2 } from 'src/modules/parkplusStoreV2/utils/events';
import { Typography } from 'ui-v2/components/Typography';
import AddToCart from '../../../AddToCart';
import s from './VoucherProductCard.module.scss';

export const VoucherProductCard = (productProp: ProductCardProp) => {
  const rootRef = useRef();
  const isEventFired = useRef(false);
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 0.5,
  });

  const { product, id, position, section } = productProp;
  const isOutOfStock = useMemo(() => product.stock === 0, []);

  useEffect(() => {
    if (inViewPort && !isEventFired.current) {
      trackProductViewedStoreV2(section, product?.productId, {
        description: product?.eventType,
      });
      isEventFired.current = true;
    }
  }, [section, inViewPort, id, product.eventType, product.productId]);

  return (
    <div className={s.root} id={id} data-index={position} ref={rootRef}>
      <div className={s.imageContainer}>
        <AnimatedImage src={product?.coverImage} alt="coverImage" />
        {product?.icon ? (
          <div className={s.icon}>
            <AnimatedImage src={product?.icon} alt="productIcon" />
          </div>
        ) : null}
        {isOutOfStock && (
          <div className={s.soldout}>
            <Typography
              label="Sold out"
              variant="body_3_medium"
              color="white_alpha_tertiary"
            />
          </div>
        )}
      </div>
      <div className={s.bottom}>
        <Typography
          label={product.title}
          variant="tiny_extended_semi_bold"
          color="secondary"
          className={s.lineClamp}
        />
        <Typography
          label={product?.subtitle1}
          className={s.lineClamp}
          variant="label_3_medium"
        />
        {product?.skuType === SkuType.FuelVoucher && (
          <Typography
            label={product?.subtitle2}
            variant="body_1_regular"
            style={{
              marginTop: '4px',
            }}
          />
        )}
        {product?.loyaltyPoints > 0 && product?.loyaltyPrice >= 0 && (
          <div className={s.mlPrice}>
            <Typography
              label={
                product?.loyaltyPrice
                  ? `${formatCurrency(product.loyaltyPrice)} using `
                  : `Claim using`
              }
              color="offer"
              variant="label_4_bold"
            />
            <AnimatedImage
              src="https://parkplus-bkt-img.parkplus.io/production/team/public/FS_20240104160730062768.png"
              className={s.drop}
              alt="mldrop"
            />
            <Typography
              label={formatFuelBalance(product?.loyaltyPoints)}
              color="offer"
              variant="label_4_bold"
            />
          </div>
        )}
      </div>
      <div className={s.addToCart}>
        <AddToCart product={product} section={section} />
      </div>
    </div>
  );
};
